import { NotebookTypes } from '@mode/notebooks/contract';
import { AppState, NotebookEditorState } from '@mode/legacy/types-app-state';
import { ReducerTree } from '@mode/legacy/util-domain';
import { Actions } from '../../../actions';
import { CellActions } from '../../../actions/notebooks/cell.actions';

export const initialNotebookEditorState: NotebookEditorState = {
  selectedNotebookToken: null,
  selectedCellToken: null,
  isResultSelected: false,
  isEditing: false,
};

export function selectedNotebookTokenReducer(
  state = initialNotebookEditorState.selectedNotebookToken,
  action: Actions
): NotebookEditorState['selectedNotebookToken'] {
  return state;
}

export function selectedCellTokenReducer(
  state = initialNotebookEditorState.selectedCellToken,
  action: Actions
): NotebookEditorState['selectedCellToken'] {
  switch (action.type) {
    case CellActions.Type.Select: // falls through
    case CellActions.Type.BeginEdit:
      return action.cellToken;
    case CellActions.Type.AddCellSuccess:
      return action.cellResource.token;
    case CellActions.Type.DestroyCell:
      // select cell below, if available
      const nextToken = action.nextCellToken;
      if (nextToken != null) {
        return nextToken;
      }

      // select cell above otherwise
      const cellTokens = action.notebookCellTokensArray.get(action.notebookToken).toArray();
      if (cellTokens.length > 1) {
        const index = cellTokens.indexOf(action.cellToken);
        if (index >= 0) {
          return cellTokens[index - 1];
        }
      }

      return null;
    case CellActions.Type.LoadNotebookCellsSuccess: {
      if (!action.cellResources.length) return;

      const firstCell = action.cellResources[0];
      const firstNonMarkDownCell = action.cellResources.find(
        (c) => c.content_type !== NotebookTypes.ContentType.Markdown
      );

      return (firstNonMarkDownCell || firstCell).token;
    }
  }

  return state;
}

// probably unnecessary
export function isResultSelectedReducer(
  state = initialNotebookEditorState.isResultSelected,
  action: Actions
): NotebookEditorState['isResultSelected'] {
  switch (action.type) {
    case CellActions.Type.Select:
      return action.resultPane;
    case CellActions.Type.BeginEdit:
      return false;
  }

  return state;
}

export function isEditingReducer(
  state = initialNotebookEditorState.isEditing,
  action: Actions
): NotebookEditorState['isEditing'] {
  switch (action.type) {
    case CellActions.Type.AddCellSuccess:
      return true;
    case CellActions.Type.BeginEdit:
      // if it's frozen, always return false regardless
      return !action.cellFrozen;
    case CellActions.Type.Select: // falls through
    case CellActions.Type.EndEdit:
      return false;
    case CellActions.Type.UpdateCell:
      return false;
    case CellActions.Type.DestroyCell:
      return false;
  }

  return state;
}

export const notebookEditorReducer: ReducerTree<AppState, NotebookEditorState, Actions> = {
  selectedNotebookToken: selectedNotebookTokenReducer,
  selectedCellToken: selectedCellTokenReducer,
  isResultSelected: isResultSelectedReducer,
  isEditing: isEditingReducer,
};
